<template>
    <div>
        <h1>Page Not Found</h1>
        <h2>
            <router-link :to="{ name: 'Home' }">Go to Home</router-link>
        </h2>
    </div>
</template>

<script>
    export default {

    };
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/partials/typography';
    @import '../../assets/scss/partials/variables';

    h1 {
        color: $kpmg-blue;
        font-size: 45px;
        margin-bottom: 52px;
        padding-top: 41px;
        text-align: center;
    }

    h2 {
        @include fontArial();
        color: $kpmg-blue;
        font-size: 26px;
        margin-bottom: 0;
        padding-top: 0;
        text-align: center;

        a:visited {
            color: inherit;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/NotFound.vue